import { Category } from '../../core';
import { UNREAD_CATEGORY_ID } from '../const/unread-category';
import { ViewCategory } from '../model/view-category.model';

export function categoryTransformer(categories: Category[]): ViewCategory[] {
    const cats =
        categories?.map<ViewCategory>((c) => ({
            ...c,
            actions: c.actions?.map((a) => ({
                ...a,
                styleHidden: null,
                styleDisabled: null,
            })),
        })) ?? [];

    const unreadCat = cats?.filter(
        (e) => e.categoryId === UNREAD_CATEGORY_ID,
    )?.[0] ?? {
        categoryId: UNREAD_CATEGORY_ID,
        icon: 'email-outline',
        colour: '#000',
    };
    const result =
        cats?.filter((e) => e.categoryId !== UNREAD_CATEGORY_ID) ?? [];

    result.sort(
        (a, b) =>
            (a.displayOrder ?? Number.MAX_SAFE_INTEGER) -
            (b.displayOrder ?? Number.MAX_SAFE_INTEGER),
    );

    result.forEach((e) => {
        e.actions?.sort(
            (a, b) =>
                (a.displayOrder ?? Number.MAX_SAFE_INTEGER) -
                (b.displayOrder ?? Number.MAX_SAFE_INTEGER),
        );
    });

    result.splice(0, 0, unreadCat);

    return result;
}
